<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

document.addEventListener("click", function (e) {
    const btn = e.target.closest(".auto-add-to-drawer");
    if (!btn) return;

    // Stop FAQ script from firing
    e.stopPropagation();

    const variantId = btn.dataset.variantId;

    fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            id: variantId,
            quantity: 1
        })
    })
    .then(res => res.json())
    .then(data => {
        console.log("Added to cart:", data);

        // Open the Ella cart drawer
        document.body.classList.add("cart-drawer-open");

        const drawer = document.querySelector("cart-drawer");
        if (drawer) {
            drawer.classList.add("is-open");
        }

        // Trigger Ella theme's drawer update
        document.dispatchEvent(new CustomEvent("theme:cart:change"));
    })
    .catch(err => console.error(err));
}, true);


document.addEventListener("DOMContentLoaded", function () {
    AOS.init({
        once: 'true'
    });
    
    new Vivus('svg-castle2', {
        type: 'oneByOne',
        duration: 300
    });
    new Vivus('custom-castle', {
        type: 'oneByOne',
        duration: 300
    });
    
});

new Vivus('castle-new', {
    type: 'oneByOne',
    duration: 300
});
new Vivus('custom-castles', {
    type: 'oneByOne',
    duration: 300
});

(function () {
  const interval = setInterval(() => {
    const iframe = document.querySelector('iframe[src*="stripe"]');

    if (iframe) {
      clearInterval(interval);

      iframe.addEventListener("load", () => {
        try {
          const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;

          const style = iframeDoc.createElement("style");
          style.innerHTML = `
            button {
              border-radius: 10px !important;
              background: #8bc43f !important;
            }

            a {
              text-decoration: underline !important;
            }
          `;
          iframeDoc.head.appendChild(style);
        } catch (e) {
          console.warn("Stripe iframe is cross-origin, CSS inject not allowed");
        }
      });
    }
  }, 300);
})();

const elements = stripe.elements({
  appearance: {
    theme: 'flat',
    variables: {
      colorPrimary: '#8bc43f',
      borderRadius: '8px',
    }
  }
});



// document.addEventListener("DOMContentLoaded", function () {

//   var html = document.documentElement;

//   /* =========================
//      Device & Browser Detection
//   ========================== */

//   if (!("ontouchstart" in window)) {
//     html.classList.add("noTouch");
//   }

//   if ("ontouchstart" in window) {
//     html.classList.add("isTouch");
//   }

//   if (document.documentMode || /Edge/.test(navigator.userAgent)) {
//     if (navigator.appVersion.indexOf("Trident") === -1) {
//       html.classList.add("isEDGE");
//     } else {
//       html.classList.add("isIE", "isIE11");
//     }
//   }

//   if (navigator.appVersion.indexOf("MSIE") !== -1) {
//     html.classList.add("isIE");
//   }

//   if (
//     navigator.userAgent.indexOf("Safari") !== -1 &&
//     navigator.userAgent.indexOf("Chrome") === -1
//   ) {
//     html.classList.add("isSafari");
//   }

//   /* =========================
//      On-Screen Detection
//   ========================== */

//   function isOnScreen(el) {
//     var rect = el.getBoundingClientRect();
//     var viewportHeight = window.innerHeight || document.documentElement.clientHeight;

//     return rect.bottom > 0 && rect.top < viewportHeight;
//   }

//   function detection() {
//     items.forEach(function (el) {
//       if (isOnScreen(el)) {
//         el.classList.add("in-view");
//       } else {
//         el.classList.remove("in-view");
//       }
//     });
//   }

//   var items = document.querySelectorAll(
//     "[data-animate-in], [data-detect-viewport]"
//   );

//   var waiting = false;

//   window.addEventListener("scroll", handleScroll);
//   window.addEventListener("resize", handleScroll);

//   function handleScroll() {
//     if (waiting) return;

//     waiting = true;
//     detection();

//     setTimeout(function () {
//       waiting = false;
//     }, 100);
//   }

//   /* =========================
//      Initial Load
//   ========================== */

//   setTimeout(function () {
//     detection();
//   }, 500);

//   items.forEach(function (el) {
//     var delay = el.getAttribute("data-animate-in-delay");
//     if (delay) {
//       el.style.transitionDelay = delay / 1000 + "s";
//     } else {
//       el.style.transitionDelay = "0s";
//     }
//   });

// });

function openBulkPopup() {
  document.getElementById("bulkPopup").style.display = "block";
}

function closeBulkPopup() {
  document.getElementById("bulkPopup").style.display = "none";
}

// Auto close after form submit (Shopify reload detection)
document.addEventListener("DOMContentLoaded", function () {
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('contact_posted') === 'true') {
    document.getElementById("bulkPopup").style.display = "none";
  }
});